class SafariCameraPermissionManager {
    private storageName = 'is-safari-camera-permission-granted';

    constructor() {
        window.sessionStorage.removeItem(this.storageName);
    }

    public setGranted() {
        window.sessionStorage.setItem(this.storageName, '1');
    }

    public get isGranted() {
        return window.sessionStorage.getItem(this.storageName) === '1';
    }
}

/**
 * Объект для работы с состоянием разрешения на использования камеры
 *
 * Объект необходим из-за особенностей работы Safari
 * */
export const safariCameraPermissionManager = new SafariCameraPermissionManager();
